export default {"src":"/_next/static/media/tactile_mark.3f030120.svg","height":40,"width":26,"blurWidth":0,"blurHeight":0};